import { render, staticRenderFns } from "./BaseDialogConfirmButton.vue?vue&type=template&id=2b87a0d2&"
import script from "./BaseDialogConfirmButton.vue?vue&type=script&lang=ts&"
export * from "./BaseDialogConfirmButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports